module.exports = __webpack_public_path__ + "static/media/emergency-call-2.e97a4c20.svg";